import { PhotoGallery } from "@avenue-8/sidekick-ui";
import { useImageGalleryStore } from "@cma/store/image-gallery.store";

export const PhotoGalleryWrapper = () => {
  const { images, initialImageIndex } = useImageGalleryStore((store) => store);
  const resetGallery = useImageGalleryStore((store) => store.resetGallery);

  return (
    <PhotoGallery
      photos={images || []}
      initialIndex={initialImageIndex}
      open={!!images}
      onClose={resetGallery}
    />
  );
};
